const v = "4.8.0";
const meta = {
  g: "LottieFiles AE 1.0.0",
  a: "",
  k: "",
  d: "",
  tc: ""
};
const fr = 30;
const ip = 0;
const op = 319;
const w = 1e3;
const h = 1e3;
const nm = "Option 3";
const ddd = 0;
const assets = [];
const layers = [
  {
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: "Top",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 40,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 60,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 80,
            s: [
              20
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 100,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 120,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 140,
            s: [
              20
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 160,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 180,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 200,
            s: [
              20
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 220,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 240,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 260,
            s: [
              20
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 280,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 300,
            s: [
              0
            ]
          },
          {
            t: 320,
            s: [
              20
            ]
          }
        ],
        ix: 10
      },
      p: {
        a: 0,
        k: [
          770,
          140,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 40,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 60,
            s: [
              80.831,
              80.831,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 80,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 100,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 120,
            s: [
              80.831,
              80.831,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 140,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 160,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 180,
            s: [
              80.831,
              80.831,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 200,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 220,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 240,
            s: [
              80.831,
              80.831,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 260,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 280,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 300,
            s: [
              80.831,
              80.831,
              100
            ]
          },
          {
            t: 320,
            s: [
              0,
              0,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -59.41,
                    -20.12
                  ],
                  [
                    0.155,
                    -0.53
                  ],
                  [
                    0.328,
                    -0.096
                  ],
                  [
                    20.59,
                    -21.34
                  ],
                  [
                    10.14,
                    -27.85
                  ],
                  [
                    0.53,
                    0.155
                  ],
                  [
                    0.096,
                    0.328
                  ],
                  [
                    59.33,
                    20.13
                  ],
                  [
                    -0.145,
                    0.533
                  ],
                  [
                    -0.342,
                    0.093
                  ],
                  [
                    -20.4,
                    58.74
                  ],
                  [
                    -0.533,
                    -0.145
                  ],
                  [
                    -0.093,
                    -0.342
                  ]
                ],
                o: [
                  [
                    0.53,
                    0.155
                  ],
                  [
                    -0.096,
                    0.328
                  ],
                  [
                    -27.59,
                    10.1
                  ],
                  [
                    -20.59,
                    21.34
                  ],
                  [
                    -0.155,
                    0.53
                  ],
                  [
                    -0.328,
                    -0.096
                  ],
                  [
                    -20.38,
                    -58.63
                  ],
                  [
                    -0.533,
                    -0.145
                  ],
                  [
                    0.093,
                    -0.342
                  ],
                  [
                    59.39,
                    -20.2
                  ],
                  [
                    0.145,
                    -0.533
                  ],
                  [
                    0.342,
                    0.093
                  ],
                  [
                    20.28,
                    58.66
                  ]
                ],
                v: [
                  [
                    118.611,
                    -0.948
                  ],
                  [
                    119.292,
                    0.292
                  ],
                  [
                    118.611,
                    0.972
                  ],
                  [
                    45.431,
                    46.312
                  ],
                  [
                    0.951,
                    120.602
                  ],
                  [
                    -0.289,
                    121.282
                  ],
                  [
                    -0.969,
                    120.602
                  ],
                  [
                    -118.599,
                    0.992
                  ],
                  [
                    -119.301,
                    -0.236
                  ],
                  [
                    -118.599,
                    -0.938
                  ],
                  [
                    -0.839,
                    -120.588
                  ],
                  [
                    0.389,
                    -121.291
                  ],
                  [
                    1.091,
                    -120.588
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 0,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.094117647059,
                0.113725490196,
                0.337254901961,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                -0.618,
                -3.144
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                106.143,
                106.143
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Shape 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 319,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: "Bottom",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 20,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 40,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 60,
            s: [
              20
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 80,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 100,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 120,
            s: [
              20
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 140,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 160,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 180,
            s: [
              20
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 200,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 220,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 240,
            s: [
              20
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 260,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 280,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 300,
            s: [
              20
            ]
          },
          {
            t: 320,
            s: [
              -22
            ]
          }
        ],
        ix: 10
      },
      p: {
        a: 0,
        k: [
          772,
          808,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          272.167,
          307.107,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 20,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 40,
            s: [
              101.743,
              101.743,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 60,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 80,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 100,
            s: [
              101.743,
              101.743,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 120,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 140,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 160,
            s: [
              101.743,
              101.743,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 180,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 200,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 220,
            s: [
              101.743,
              101.743,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 240,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 260,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 280,
            s: [
              101.743,
              101.743,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 300,
            s: [
              0,
              0,
              100
            ]
          },
          {
            t: 320,
            s: [
              0,
              0,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -83.96,
                    -28.42
                  ],
                  [
                    0.261,
                    -0.751
                  ],
                  [
                    0.416,
                    -0.145
                  ],
                  [
                    29.08,
                    -30.06
                  ],
                  [
                    14.27,
                    -39.38
                  ],
                  [
                    0.751,
                    0.262
                  ],
                  [
                    0.144,
                    0.416
                  ],
                  [
                    83.84,
                    28.45
                  ],
                  [
                    -0.244,
                    0.751
                  ],
                  [
                    -0.435,
                    0.142
                  ],
                  [
                    -28.82,
                    82.99
                  ],
                  [
                    -0.754,
                    -0.253
                  ],
                  [
                    -0.144,
                    -0.427
                  ]
                ],
                o: [
                  [
                    0.751,
                    0.261
                  ],
                  [
                    -0.145,
                    0.415
                  ],
                  [
                    -39,
                    14.26
                  ],
                  [
                    -29.08,
                    30.06
                  ],
                  [
                    -0.261,
                    0.751
                  ],
                  [
                    -0.416,
                    -0.144
                  ],
                  [
                    -28.8,
                    -82.84
                  ],
                  [
                    -0.751,
                    -0.244
                  ],
                  [
                    0.141,
                    -0.435
                  ],
                  [
                    83.91,
                    -28.54
                  ],
                  [
                    0.253,
                    -0.754
                  ],
                  [
                    0.427,
                    0.144
                  ],
                  [
                    28.65,
                    82.84
                  ]
                ],
                v: [
                  [
                    167.592,
                    -1.384
                  ],
                  [
                    168.479,
                    0.449
                  ],
                  [
                    167.592,
                    1.336
                  ],
                  [
                    64.202,
                    65.396
                  ],
                  [
                    1.352,
                    170.396
                  ],
                  [
                    -0.481,
                    171.282
                  ],
                  [
                    -1.368,
                    170.396
                  ],
                  [
                    -167.578,
                    1.396
                  ],
                  [
                    -168.496,
                    -0.406
                  ],
                  [
                    -167.578,
                    -1.324
                  ],
                  [
                    -1.198,
                    -170.384
                  ],
                  [
                    0.626,
                    -171.291
                  ],
                  [
                    1.532,
                    -170.384
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 0,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.094117647059,
                0.113725490196,
                0.337254901961,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                266.938,
                308.172
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Shape 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 319,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: "Left",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 0,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 20,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 40,
            s: [
              20
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 60,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 80,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 100,
            s: [
              20
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 120,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 140,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 160,
            s: [
              20
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 180,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 200,
            s: [
              0
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 220,
            s: [
              20
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 240,
            s: [
              -22
            ]
          },
          {
            i: {
              x: [
                0.667
              ],
              y: [
                1
              ]
            },
            o: {
              x: [
                0.333
              ],
              y: [
                0
              ]
            },
            t: 260,
            s: [
              0
            ]
          },
          {
            t: 280,
            s: [
              20
            ]
          }
        ],
        ix: 10
      },
      p: {
        a: 0,
        k: [
          329,
          462,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 0,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 20,
            s: [
              98.181,
              98.181,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 40,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 60,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 80,
            s: [
              98.2,
              98.2,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 100,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 120,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 140,
            s: [
              98.2,
              98.2,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 160,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 180,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 200,
            s: [
              98.2,
              98.2,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 220,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 240,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 260,
            s: [
              98.2,
              98.2,
              100
            ]
          },
          {
            t: 280,
            s: [
              0,
              0,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    sy: [
      {
        bm: {
          a: 0,
          k: 1,
          ix: 1
        },
        c: {
          a: 0,
          k: [
            0.0941176489,
            0.113725490868,
            0.337254911661,
            1
          ],
          ix: 2
        },
        so: {
          a: 0,
          k: 100,
          ix: 3
        },
        ty: 7,
        nm: "Color Overlay"
      }
    ],
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -161.57,
                    -54.69
                  ],
                  [
                    0.462,
                    -1.453
                  ],
                  [
                    0.812,
                    -0.289
                  ],
                  [
                    56,
                    -57.92
                  ],
                  [
                    27.5,
                    -75.72
                  ],
                  [
                    1.444,
                    0.505
                  ],
                  [
                    0.278,
                    0.797
                  ],
                  [
                    161.34,
                    54.74
                  ],
                  [
                    -0.471,
                    1.45
                  ],
                  [
                    -0.84,
                    0.273
                  ],
                  [
                    -55.47,
                    159.72
                  ],
                  [
                    -1.447,
                    -0.479
                  ],
                  [
                    -0.274,
                    -0.828
                  ]
                ],
                o: [
                  [
                    1.453,
                    0.462
                  ],
                  [
                    -0.261,
                    0.822
                  ],
                  [
                    -75,
                    27.45
                  ],
                  [
                    -56,
                    57.92
                  ],
                  [
                    -0.504,
                    1.444
                  ],
                  [
                    -0.797,
                    -0.278
                  ],
                  [
                    -55.34,
                    -159.44
                  ],
                  [
                    -1.45,
                    -0.471
                  ],
                  [
                    0.273,
                    -0.841
                  ],
                  [
                    161.48,
                    -54.94
                  ],
                  [
                    0.479,
                    -1.447
                  ],
                  [
                    0.828,
                    0.274
                  ],
                  [
                    55.06,
                    159.52
                  ]
                ],
                v: [
                  [
                    322.459,
                    -2.577
                  ],
                  [
                    324.252,
                    0.889
                  ],
                  [
                    322.549,
                    2.653
                  ],
                  [
                    123.549,
                    125.933
                  ],
                  [
                    2.549,
                    327.933
                  ],
                  [
                    -0.98,
                    329.634
                  ],
                  [
                    -2.681,
                    327.933
                  ],
                  [
                    -322.471,
                    2.683
                  ],
                  [
                    -324.244,
                    -0.795
                  ],
                  [
                    -322.471,
                    -2.567
                  ],
                  [
                    -2.271,
                    -327.907
                  ],
                  [
                    1.217,
                    -329.659
                  ],
                  [
                    2.969,
                    -327.907
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "Path 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 0,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.094117647059,
                0.113725490196,
                0.337254901961,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Shape 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 319,
    st: 0,
    bm: 0
  }
];
const markers = [];
const branclubloading = {
  v,
  meta,
  fr,
  ip,
  op,
  w,
  h,
  nm,
  ddd,
  assets,
  layers,
  markers
};
export {
  assets,
  ddd,
  branclubloading as default,
  fr,
  h,
  ip,
  layers,
  markers,
  meta,
  nm,
  op,
  v,
  w
};
//# sourceMappingURL=brandclub_logo_load.json.js.map
